module.exports = __webpack_public_path__ + "img/loading-failure.9a7de31d.png";